import React from "react";
import { useTheme } from "@emotion/react";
import {
  AppBar,
  Backdrop,
  CircularProgress,
  Container,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import * as Yup from "yup";
import RadioButtonComponent from "../../components/forms/RadioButtonComponent";
import Form from "../../components/forms/Form";
import InputComponent from "../../components/forms/InputComponent";
import SubmitButton from "../../components/forms/SubmitButton";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { brandCreate } from "../../actions/brandActions";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { CATEGORY_CREATE_RESET } from "../../constants/categoryConstants";
import { createCategory } from "../../actions/categoryActions";
import { ATTRIBUTE_CREATE_RESET } from "../../constants/attributeConstants";
import { createAttribute } from "../../actions/attributeActions";

const validationSchema = Yup.object().shape({
  name: Yup.string()
    .required("Name is required")
    .min(1, "Name must be at least 1 characters"),
  status: Yup.boolean().required("Status is required").default(false),
});

const CreateAttribute = () => {
  const dispatch = useDispatch();

  const { palette } = useTheme();
  const navigate = useNavigate();

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const attributeCreate = useSelector((state) => state.attributeCreate);
  const { loading, error, success } = attributeCreate;

  useEffect(() => {
    if (!userInfo) {
      navigate("/", { replace: true });
    }
    if (success) {
      dispatch({ type: ATTRIBUTE_CREATE_RESET });
      navigate("/attribute");
      toast("Attribute created successfully");
    }
  }, [userInfo, dispatch, navigate, success]);

  const handleSubmit = async ({ name, status }) => {
    dispatch(createAttribute(name, status));
  };

  return (
    <Container>
      {loading && (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={true}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          pt: 10,
          backgroundColor: palette.background.default,
        }}
      >
        {error && <Typography color="error">{error}</Typography>}

        <Typography variant="h5" component="h2">
          Add Attribute
        </Typography>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "50%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Form
            initialValues={{
              name: "",
              status: false,
            }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            <InputComponent label="name" />
            <RadioButtonComponent name="status" />
            <SubmitButton title={"Add Attribute"} />
          </Form>
        </div>
      </Box>
    </Container>
  );
};

export default CreateAttribute;
